// import { HStack, Image, Box, Text } from '@chakra-ui/react';
// import { useEffect, useState } from 'react';

// import weeamLogo from 'assets/logo-crm.png';
// import SIPSwitch from 'components/switch';
// import './styles.css';
// import { useDispatch } from 'react-redux';
// import { updateSipStatus } from './../../../redux/webrtc/webrtcSlice';
// import useUserSession from 'hooks/useUserSession';
// import { useModalColors } from 'hooks/useModalColors';

// function Footer({
// 	status,
// 	setStatus,
// 	sipServerAddress,
// 	sipUsername,
// 	sipDomain,
// 	sipPassword,
// 	sipDisplayName,
// 	isSwitchingUserStatus,
// 	setIsSwitchingUserStatus,
// 	isOnline,
// 	setIsOnline,
// 	onHandleGoOffline,
// }) {
// 	const [isConfigured, setIsConfigured] = useState(false);
// 	const dispatch = useDispatch();
// 	const colors = useModalColors();
// const {agencyLogo,agencyName}=useUserSession()
// 	// **** Add user status in redux store **** //
// 	useEffect(() => {
// 		if (status === 'registered' || status === 'disconnected') {
// 			setIsSwitchingUserStatus(false);
// 			setIsOnline(status === 'registered');
// 			dispatch(updateSipStatus(status));
// 		}
// 	}, [status, setIsSwitchingUserStatus, setIsOnline, dispatch]);

// 	useEffect(() => {
// 		if (sipDomain && sipUsername && sipPassword && sipServerAddress) {
// 			setIsConfigured(true);
// 		} else {
// 			setIsConfigured(false);
// 		}
// 	}, [sipDomain, sipUsername, sipPassword, sipServerAddress]);

// 	return (
// 		// <HStack
// 		// 	padding={'15px'}
// 		// 	justifyContent={'space-between'}
// 		// 	alignItems={'center'}
// 		// 	bg={'grey.75'}
// 		// >
// 		// 	{isConfigured ? (
// 		// 		<HStack alignItems={'center'} flexWrap={'nowrap'} className='xs'>
// 		// 			<SIPSwitch
// 		// 				isDisabled={isSwitchingUserStatus}
// 		// 				checked={[isOnline, setIsOnline]}
// 		// 				onChange={(v) => {
// 		// 					setIsSwitchingUserStatus(true);
// 		// 					onHandleGoOffline(v ? 'registered' : 'unregistered');
// 		// 				}}
// 		// 			/>
// 		// 			<Text>You are {isOnline ? 'online' : 'offline'}</Text>
// 		// 		</HStack>
// 		// 	) : (
// 		// 		<span></span>
// 		// 	)}
// 		// 	<HStack
// 		// 		spacing={1}
// 		// 		alignItems={'start'}
// 		// 		justify={'flex-end'}
// 		// 		flexWrap={'wrap'}
// 		// 		align={'center'}
// 		// 	>
// 		// 		<Text fontSize='14px'>Powered by</Text>
// 		// 		<Image
// 		// 			src={weeamLogo}
// 		// 			alt='weeam Logo'
// 		// 			w='40px'
// 		// 			h='40px'
// 		// 			objectFit='contain'
// 		// 		/>
// 		// 	</HStack>
// 		// </HStack>
// 		<HStack
// 			px='12px'
// 			py='10px'
// 			justifyContent='space-between'
// 			alignItems='center'
// 			bg='softGray.100'
// 			borderBottom='1px solid'
// 			borderColor='softGray.600'
// 			spacing={3}
// 		>
// 			{/* Left Side — Online Status */}
// 			{isConfigured ? (
// 				<HStack spacing={2} alignItems='center' whiteSpace='nowrap'>
// 					<SIPSwitch
// 						isDisabled={isSwitchingUserStatus}
// 						checked={[isOnline, setIsOnline]}
// 						onChange={(v) => {
// 							setIsSwitchingUserStatus(true);
// 							onHandleGoOffline(v ? 'registered' : 'unregistered');
// 						}}
// 						size='sm'
// 					/>

// 					<Text fontSize='13px' fontWeight='medium' color='gray.700'>
// 						{isOnline ? 'Online' : 'Offline'}
// 					</Text>
// 				</HStack>
// 			) : (
// 				<Box w='1px' />
// 			)}

// 			{/* Right Side — Powered By */}
// 			{/* <HStack spacing={1.5} alignItems='center'>
// 				<Text fontSize='12px' color='gray.800' opacity={0.9}>
// 					Powered by
// 				</Text>

// 				<Image
// 					src={agencyLogo}
// 					alt={agencyName}
// 					w='32px'
// 					h='32px'
// 					objectFit='contain'
// 					opacity={0.95}
// 				/>
// 			</HStack>
// 			 */}
// 			 <HStack spacing={1.5} alignItems='center'>
// 	<Text fontSize='12px' color='gray.800' opacity={0.9}>
// 		Powered by
// 	</Text>

// 	{agencyLogo ? (
// 		<Image
// 			src={agencyLogo}
// 			alt={agencyName}
// 			w='32px'
// 			h='32px'
// 			objectFit='contain'
// 			opacity={0.95}
// 			fallbackSrc="https://via.placeholder.com/32?text=Logo"
// 			onError={(e) => {
// 				e.target.style.display = 'none';
// 				e.target.nextSibling.style.display = 'flex';
// 			}}
// 		/>
// 	) : (
// 		<Box
// 			w='32px'
// 			h='32px'
// 			bg={colors.bgInput}
// 			borderRadius='md'
// 			display='flex'
// 			alignItems='center'
// 			justifyContent='center'
// 			border='1px solid'
// 			borderColor={colors.borderColor}
// 		>
// 			<Text fontSize='10px' color={colors.mutedText}>
// 				{agencyName?.charAt(0) || 'W'}
// 			</Text>
// 		</Box>
// 	)}
// </HStack>
// 		</HStack>
// 	);
// }

// export default Footer;


import { HStack, Image, Box, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import weeamLogo from 'assets/logo-crm.png';
import SIPSwitch from 'components/switch';
import './styles.css';
import { useDispatch } from 'react-redux';
import { updateSipStatus } from './../../../redux/webrtc/webrtcSlice';
import useUserSession from 'hooks/useUserSession';
import { useModalColors } from 'hooks/useModalColors';

function Footer({
	status,
	setStatus,
	sipServerAddress,
	sipUsername,
	sipDomain,
	sipPassword,
	sipDisplayName,
	isSwitchingUserStatus,
	setIsSwitchingUserStatus,
	isOnline,
	setIsOnline,
	onHandleGoOffline,
}) {
	const [isConfigured, setIsConfigured] = useState(false);
	const dispatch = useDispatch();
	const colors = useModalColors();
	const { agencyLogo, agencyName } = useUserSession();

	// **** Add user status in redux store **** //
	useEffect(() => {
		if (status === 'registered' || status === 'disconnected') {
			setIsSwitchingUserStatus(false);
			setIsOnline(status === 'registered');
			dispatch(updateSipStatus(status));
		}
	}, [status, setIsSwitchingUserStatus, setIsOnline, dispatch]);

	useEffect(() => {
		if (sipDomain && sipUsername && sipPassword && sipServerAddress) {
			setIsConfigured(true);
		} else {
			setIsConfigured(false);
		}
	}, [sipDomain, sipUsername, sipPassword, sipServerAddress]);

	return (
		<HStack
			px='16px'
			py='12px'
			justifyContent='space-between'
			alignItems='center'
			bg={colors.footerBg}
			borderTop='1px solid'
			borderColor={colors.borderColor}
			spacing={3}
		>
			{/* Left Side — Online Status */}
			{isConfigured ? (
				<HStack spacing={2} alignItems='center' whiteSpace='nowrap'>
					<SIPSwitch
						isDisabled={isSwitchingUserStatus}
						checked={[isOnline, setIsOnline]}
						onChange={(v) => {
							setIsSwitchingUserStatus(true);
							onHandleGoOffline(v ? 'registered' : 'unregistered');
						}}
						size='sm'
					/>

					<Text 
						fontSize='13px' 
						fontWeight='medium' 
						color={isOnline ? colors.badgeSuccessText : colors.mutedText}
					>
						{isOnline ? 'Online' : 'Offline'}
					</Text>
				</HStack>
			) : (
				<Box w='1px' />
			)}

			{/* Right Side — Powered By */}
			<HStack spacing={1.5} alignItems='center'>
				<Text fontSize='12px' color={colors.mutedText}>
					Powered by
				</Text>

				{agencyLogo ? (
					<Image
						src={agencyLogo}
						alt={agencyName}
						w='32px'
						h='32px'
						objectFit='contain'
						opacity={0.9}
						fallback={
							<Box
								w='32px'
								h='32px'
								bg={colors.bgInput}
								borderRadius='md'
								display='flex'
								alignItems='center'
								justifyContent='center'
								border='1px solid'
								borderColor={colors.borderColor}
							>
								<Text fontSize='10px' color={colors.accentGold} fontWeight='bold'>
									{agencyName?.charAt(0).toUpperCase() || 'W'}
								</Text>
							</Box>
						}
					/>
				) : (
					<Box
						w='32px'
						h='32px'
						bg={colors.bgInput}
						borderRadius='md'
						display='flex'
						alignItems='center'
						justifyContent='center'
						border='1px solid'
						borderColor={colors.borderColor}
					>
						<Text fontSize='12px' color={colors.accentGold} fontWeight='bold'>
							{agencyName?.charAt(0).toUpperCase() || 'W'}
						</Text>
					</Box>
				)}
			</HStack>
		</HStack>
	);
}

export default Footer;